import { useCallback } from 'react';
import { ResolvedMatch, MeetingFormData } from '../interfaces/interface';
import { MeetingService } from '../services/MeetingService';

export const useOutlookIntegration = () => {
  const buildResolvedData = useCallback((resolvedAttendees: ResolvedMatch[]) => {
    return MeetingService.buildAttendeeData(resolvedAttendees);
  }, []);

  const handleOutlookWeb = useCallback((formData: MeetingFormData, resolvedAttendees: ResolvedMatch[]) => {
    const outlookUrl = MeetingService.generateOutlookWebUrl(formData, resolvedAttendees);
    window.open(outlookUrl, '_blank');
  }, []);

  const collectExecutiveAssistants = useCallback((resolvedAttendees: ResolvedMatch[]) => {
    return MeetingService.collectExecutiveAssistants(resolvedAttendees);
  }, []);

  const handleSendNoteToEAs = useCallback((formData: MeetingFormData, resolvedAttendees: ResolvedMatch[], onError?: (message: string) => void) => {
    try {
      const mailtoUrl = MeetingService.generateEAMailtoUrl(formData, resolvedAttendees);
      window.open(mailtoUrl, '_blank');
    } catch (error) {
      if (onError) {
        onError(
          (error as Error).message || 'Failed to send note to Executive Assistants. Please try again or contact support if the issue persists.'
        );
      }
    }
  }, []);

  return {
    buildResolvedData,
    handleOutlookWeb,
    collectExecutiveAssistants,
    handleSendNoteToEAs
  };
};
